import React, { useMemo } from 'react';
import { Box, ContentFrame, LayoutContent, ScreenContainer, } from '@pinwheel/origami';
import ModalHeader from '../components/ModalHeader';
import { useAppSelector } from '../state';
import { selectFeatureFlags, selectIsCompanyConnectJob, } from '../state/slices/slice-link-params';
import './ExternalPage.scss';
import { useOpts } from '../context';
// https://github.com/underdog-tech/s3-upload-ci/tree/main/files is repo
// where we store static files for the CDN (i.e. source of truth for
// the linked HTML files)
var FCRA_TERMS = 'https://cdn.getpinwheel.com/terms-fcra.html';
var TERMS = 'https://cdn.getpinwheel.com/terms.html';
var TERMS_ES = 'https://cdn.getpinwheel.com/terms_es.html';
var COMPANY_CONNECT_TERMS = 'https://cdn.getpinwheel.com/terms-company-connect.html';
var FCRA_PRIVACY = 'https://cdn.getpinwheel.com/privacy-fcra.html';
var PRIVACY = 'https://cdn.getpinwheel.com/privacy_policy.html';
var PRIVACY_ES = 'https://cdn.getpinwheel.com/privacy_policy_es.html';
function ExternalPage(_a) {
    var title = _a.title;
    var featureFlags = useAppSelector(selectFeatureFlags);
    var isCompanyConnectJob = useAppSelector(selectIsCompanyConnectJob);
    var linkTokenPayload = useOpts().linkTokenPayload;
    var link = useMemo(function () {
        var language = (linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.language)
            ? linkTokenPayload.language
            : 'en';
        var isFcraWorkspace = featureFlags.usingFcra;
        if (isFcraWorkspace) {
            return title === 'terms' ? FCRA_TERMS : FCRA_PRIVACY;
        }
        if (title === 'privacyPolicy') {
            return language === 'es' ? PRIVACY_ES : PRIVACY;
        }
        if (isCompanyConnectJob) {
            return COMPANY_CONNECT_TERMS;
        }
        return language === 'es' ? TERMS_ES : TERMS;
    }, [featureFlags.usingFcra, title, isCompanyConnectJob, linkTokenPayload]);
    return (React.createElement(ScreenContainer, { "data-testid": "external-page" },
        React.createElement(ModalHeader, { hideExitButton: true }),
        React.createElement(ContentFrame, { sx: {
                paddingBottom: '2',
            } },
            React.createElement(LayoutContent, null,
                React.createElement(Box, { as: "iframe", sx: {
                        display: 'flex',
                        width: '100%',
                        height: '100%',
                        border: 0,
                    }, "data-testid": "external-page-iframe", className: "external-page", title: title, src: link })))));
}
export default ExternalPage;
